import { useNavigate } from 'react-router-dom';
import { Users, Globe, Layers, Building2, MapPin, Swords, Target, BookOpen, Gift, BarChart3 } from 'lucide-react';

const modules = [
  { path: '/admin/usuarios', icon: Users, label: 'Gestion de Usuarios', desc: 'Crear, editar y eliminar usuarios' },
  { path: '/admin/paises', icon: Globe, label: 'Gestion de Paises', desc: 'Administrar paises participantes' },
  { path: '/admin/etapas', icon: Layers, label: 'Gestion de Etapas', desc: 'Configurar etapas del torneo' },
  { path: '/admin/estadios', icon: Building2, label: 'Gestion de Estadios', desc: 'Administrar estadios' },
  { path: '/admin/sedes', icon: MapPin, label: 'Gestion de Sedes', desc: 'Pais/ciudad de partidos' },
  { path: '/admin/partidos', icon: Swords, label: 'Gestion de Partidos', desc: 'Crear y administrar partidos' },
  { path: '/admin/resultados', icon: Target, label: 'Marcadores y Puntos', desc: 'Cargar resultados y calcular ranking' },
  { path: '/ranking', icon: BarChart3, label: 'Ranking', desc: 'Ver ranking global y por etapa' },
  { path: '/admin/reglas', icon: BookOpen, label: 'Reglas del Juego', desc: 'Administrar reglas informativas' },
  { path: '/admin/premios', icon: Gift, label: 'Premios', desc: 'Administrar premios a disputar' },
];

export default function AdminDashboard() {
  const navigate = useNavigate();

  return (
    <div className="space-y-6 animate-fade-in" data-testid="admin-dashboard">
      <div>
        <h2 className="text-2xl font-extrabold text-white" style={{ fontFamily: 'Montserrat' }}>
          Bienvenido <span className="text-[#F4E39E]">Administrador</span>
        </h2>
        <p className="text-white/50 text-sm mt-1">Gestione el panel con estas herramientas</p>
        <div className="inline-flex items-center gap-2 mt-2 px-3 py-1 rounded-full bg-green-500/20 text-green-400 text-xs font-semibold">
          <div className="w-2 h-2 rounded-full bg-green-400" />
          Estado: Activo
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-3 lg:gap-4">
        {modules.map((mod) => (
          <button
            key={mod.path}
            onClick={() => navigate(mod.path)}
            data-testid={`admin-module-${mod.path.split('/').pop()}`}
            className="w-full glass-card p-4 flex items-center gap-4 hover:border-[#F4E39E]/40 hover:-translate-y-0.5 transition-all text-left"
          >
            <div className="w-10 h-10 rounded-xl bg-[#F4E39E]/10 flex items-center justify-center flex-shrink-0">
              <mod.icon size={20} className="text-[#F4E39E]" />
            </div>
            <div>
              <h3 className="text-white font-semibold text-sm">{mod.label}</h3>
              <p className="text-white/40 text-xs">{mod.desc}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
